import React from "react";

const TargetChip = ({ target, onRemove }) => {
  return (
    <div className="target-chip">
      <span className="target-text">{target}</span>
      <button
        type="button"
        className="remove-button"
        onClick={() => onRemove(target)}
        aria-label={`Remove target ${target}`}
      >
        ✕
      </button>
    </div>
  );
};

export default TargetChip;
